/** 上傳檔案對外 URL 的 API 來源（非前端 dev server origin） */
export const getUploadsOrigin = () => {
    const configured = import.meta.env.VITE_API_BASE_URL?.trim();
    if (configured) {
        return configured.replace(/\/$/, '').replace(/\/api$/, '');
    }

    if (import.meta.env.DEV) {
        return (
            import.meta.env.VITE_DEV_API_PROXY || 'http://127.0.0.1:8201'
        ).replace(/\/$/, '');
    }

    return window.location.origin.replace(/\/$/, '');
};

/**
 * 將 DB 儲存路徑或完整 URL 轉成瀏覽器可載入的圖片網址。
 */
export const resolveUploadAssetUrl = (value) => {
    const raw = typeof value === 'string' ? value.trim() : '';
    if (!raw) {
        return '';
    }

    if (/^blob:|^data:/i.test(raw)) {
        return raw;
    }

    if (/^https?:\/\//i.test(raw)) {
        try {
            const parsed = new URL(raw);
            const match = parsed.pathname.match(/^\/storage\/(.+)$/);
            if (match) {
                return `${getUploadsOrigin()}/storage/${match[1]}`;
            }
        } catch {
            // 無效 URL，改走下方路徑正規化
        }
        return raw;
    }

    const path = raw.replace(/^\/storage\//, '').replace(/^\//, '');

    return `${getUploadsOrigin()}/storage/${path}`;
};
